// extracted by mini-css-extract-plugin
export default {"swapLanguage":"language-switcher_swapLanguage__I6OXz"};